import moment from "moment";
const state = () => ({
  usersList: [],
  usersListCustomersPage: [],
  selectedSchemeResults: [],
  salutationsList: [],
  customersList: [],
  customersDropdownList: [],
  rolesList: [],
  nesletterFrequencyList: [],
  showAdd: false,
  userObject: {
    email: "",
    person: {
      firstName: "",
      lastName: "",
      endDate: null,
      startDate: null,
      sasEndDate: null,
      sasStartDate: null,
      createdDate: null,
      salutation: null,
      customer: "",
      department: "",
      mobileNumber: "",
      isReceivingSystemMails: true,
      isAccountManager: false,
      hasSasTaskEmails: false,
      usesAIAssistant: false
    },
    roles: [{}],
    hasSasCustomer: false,
    customerUsesAIAssistant: false
  },
  newsletterFrequencyOfTheSelectedUser: "",
  modalErrorMessage: "",
  hasModalError: false,
  showSuccessfullyUpdatedDialog: false,
  pagination: {
    sortBy: "desc",
    descending: false,
    page: 1,
    rowsPerPage: 50,
    rowsNumber: null
  },
  showEmailSentDialog: false,
  selectedFavoriteLocations: [],
  favoriteAudienceTagsString: "",
  //This is just hidden for now, don't remove it:
  //favoriteIndustriesTagsString: '',
  favoritePurposesTagsString: "",
  favoriteAudiencesIdsArray: [],
  //This is just hidden for now, don't remove it:
  //favoriteIndustriesIdsArray: [],
  favoritePurposesIdsArray: [],
  audience: { options: [], label: "" },
  //This is just hidden for now, don't remove it:
  //industries: { options: [], label: '' },
  locations: { options: [], label: "" },
  purposes: { options: [], label: "" },
  schemeTypes: { options: [], label: "" },
  projectTypes: { options: [], label: "" },
  general: [],
  //countriesList: [],
  usersListDefaultEnv: [],
  filter: {
    searchTerm: "",
    filterToggleActive: true,
    filterToggleInactive: true
  },
  allRoles: [],
  paginationCustomers: {
    sortBy: "desc",
    descending: false,
    page: 1,
    rowsPerPage: 50,
    rowsNumber: null
  },
  prefilledCustomer: {
    name: "",
    id: 0
  },
  passwordResetSuccessModal: false,
  showReactivateSoftDeletedUserModal: false,
  sasRolesForCreate: [],
  contentRolesForCreate: [],
  firstCategorization: {},
  secondCategorization: {}
});

const getters = {};
const actions = {};

const mutations = {
  updateCategorizations(state, val) {
    if (val && val.length > 0) {
      state.firstCategorization.parentName = val[0].name;
      state.firstCategorization.parentId = val[0].id;
      state.firstCategorization.categories = val[0].categories;

      if (val[1]) {
        state.secondCategorization.parentName = val[1].name;
        state.secondCategorization.parentId = val[1].id;
        state.secondCategorization.categories = val[1].categories;
      }
    }
  },

  updateRolesForCreateUser(state, val) {
    state.sasRolesForCreate = val.sasRoles;
    state.contentRolesForCreate = val.contentRoles;
  },

  updateShowReactivateSoftDeletedUserModal(state, val) {
    state.showReactivateSoftDeletedUserModal = val;
  },
  setPasswordResetSuccessModal(state, val) {
    state.passwordResetSuccessModal = val;
  },
  prefillCustomer(state, val) {
    state.prefilledCustomer.name = val.name;
    state.prefilledCustomer.id = val.id;
  },
  removePrefilledCustomer(state) {
    state.prefilledCustomer.name = "";
    state.prefilledCustomer.id = 0;
  },

  updateAllRolesAndPermissions(state, val) {
    if (val != null && val.length > 0) {
      for (let i = 0; i < val.length; i++) {
        state.allRoles.push({
          id: val[i].id,
          name: val[i].name,
          permissions: val[i].permissions
        });
      }
    }
  },
  updateUsesAIAssistant(state, val) {
    state.userObject.person.usesAIAssistant = val;
  },

  updateFilter(state, filter) {
    state.filter.searchTerm = filter.searchTerm;
    state.filter.filterToggleActive = filter.filterToggleActive;
    state.filter.filterToggleInactive = filter.filterToggleInactive;
  },
  updateFilterActivities(state, activities) {
    state.general = activities;
    state.audience = activities.audience;
    //This is just hidden for now, don't remove it:
    //state.industries = activities.industries;
    state.locations = activities.locations;
    state.purposes = activities.purposes;
    state.schemeTypes = activities.schemeTypes;
    state.projectTypes = activities.projectTypes;
  },
  updateFavoriteAudiencesIdsArray(state, val) {
    if (state.favoriteAudiencesIdsArray.length > 0)
      state.favoriteAudiencesIdsArray = [];
    for (let i = 0; i < val.length; i++)
      state.favoriteAudiencesIdsArray.push(val[i]);

    state.favoriteAudienceTagsString = String(state.favoriteAudiencesIdsArray);
  },
  //This is just hidden for now, don't remove it:
  /*
  updateFavoriteIndustriesIdsArray(state, val) {
    if (state.favoriteIndustriesIdsArray.length > 0)
      state.favoriteIndustriesIdsArray = [];
    for (let i = 0; i < val.length; i++)
      state.favoriteIndustriesIdsArray.push(val[i]);
  },
  */
  updateFavoritePurposesIdsArray(state, val) {
    if (state.favoritePurposesIdsArray.length > 0)
      state.favoritePurposesIdsArray = [];
    for (let i = 0; i < val.length; i++)
      state.favoritePurposesIdsArray.push(val[i]);

    state.favoritePurposesTagsString = String(state.favoritePurposesIdsArray);
  },

  updateSelectedFavoriteLocations(state, val) {
    state.selectedFavoriteLocations = val;
  },

  updatePagination(state, val) {
    state.pagination.rowsPerPage = val.size;
    state.pagination.rowsNumber = val.count;
  },
  updatePaginationCustomers(state, val) {
    state.paginationCustomers.rowsPerPage = val.size;
    state.paginationCustomers.rowsNumber = val.count;
  },
  updatePaginationPage(state, val) {
    state.pagination.sortBy = val.sortBy;
    state.pagination.descending = val.descending;
    state.pagination.page = val.page;
  },
  updatePaginationPageCustomers(state, val) {
    state.pagination.sortBy = val.sortBy;
    state.pagination.descending = val.descending;
    state.pagination.page = val.page;
  },
  updateUsersList(state, users) {
    state.usersList = users;
  },

  updateUsersListCustomersPage(state, users) {
    state.usersListCustomersPage = users;
  },

  updateUsersListDefaultEnv(state, users) {
    state.usersListDefaultEnv = users;
  },
  updateSalutationsList(state, salutations) {
    state.salutationsList = salutations;
  },
  updateCustomersList(state, customers) {
    state.customersList = customers;
  },
  updateCustomersDropdownList(state, customers) {
    state.customersDropdownList = customers;
  },
  updateRolesList(state, roles) {
    state.rolesList = roles;
  },
  updateNewsletterFrequencyOptionsList(state, list) {
    state.newsletterFrequencyList = list;
  },
  enableAdd(state) {
    state.showAdd = true;
  },
  disableAdd(state) {
    state.showAdd = false;
  },
  updateUserObject(state, user) {
    state.userObject.email = user.email;
    state.userObject.roles = user.roles;
    state.userObject.hasSasCustomer = user.hasSasCustomer;
    state.userObject.person.firstName = user.person.firstName;
    state.userObject.person.lastName = user.person.lastName;
    state.userObject.person.salutation = user.person.salutation;
    state.userObject.person.language = user.person.language;
    state.userObject.person.customer = user.person.customer;
    state.userObject.person.customerId = user.person.customerId;

    state.userObject.person.department = user.person.department;
    state.userObject.person.mobileNumber = user.person.mobileNumber;
    state.userObject.person.isReceivingSystemMails =
      user.person.isReceivingSystemMails;
    state.userObject.person.isAccountManager = user.person.isAccountManager;
    state.userObject.person.hasSasTaskEmails = user.person.hasSasTaskEmails;
    state.userObject.person.endDate =
      user.person.endDate == null || user.person.endDate == ""
        ? null
        : moment(user.person.endDate).format("DD-MM-YYYY");
    state.userObject.person.startDate =
      user.person.startDate == null || user.person.startDate == ""
        ? null
        : moment(user.person.startDate).format("DD-MM-YYYY");
    state.userObject.person.sasEndDate =
      user.person.sasEndDate == null || user.person.sasEndDate == ""
        ? null
        : moment(user.person.sasEndDate).format("DD-MM-YYYY");
    state.userObject.person.sasStartDate =
      user.person.sasStartDate == null || user.person.sasStartDate == ""
        ? null
        : moment(user.person.sasStartDate).format("DD-MM-YYYY");
    state.userObject.person.createdDate =
      user.person.createdDate == null || user.person.createdDate == ""
        ? null
        : moment(user.person.createdDate).format("DD-MM-YYYY");

    state.userObject.person.department = user.person.department;
    state.userObject.person.mobileNumber = user.person.mobileNumber;
    state.userObject.person.usesAIAssistant = user.usesAIAssistant;
    state.userObject.customerUsesAIAssistant = user.customerUsesAIAssistant;
  },
  updateEmail(state, email) {
    state.userObject.email = email;
  },
  updateFirstName(state, firstName) {
    state.userObject.person.firstName = firstName;
  },
  updateLastName(state, lastName) {
    state.userObject.person.lastName = lastName;
  },
  updateDepartment(state, department) {
    state.userObject.person.department = department;
  },
  updateMobileNumber(state, mobNumber) {
    state.userObject.person.mobileNumber = mobNumber;
  },
  updateSalutation(state, salutation) {
    state.userObject.person.salutation = salutation;
  },
  updateReceivingSystemMails(state, isReceivingSystemMails) {
    state.userObject.person.isReceivingSystemMails = isReceivingSystemMails;
  },
  updateHasSasTaskEmails(state, val) {
    state.userObject.person.hasSasTaskEmails = val;
  },
  updateIsAccountManager(state, isAccountManager) {
    state.userObject.person.isAccountManager = isAccountManager;
  },
  updateCustomer(state, customer) {
    state.userObject.person.customer = customer;
  },
  updateCustomerId(state, customerId) {
    state.userObject.person.customerId = customerId;
  },
  updateNewsletterFrequency(state, selectedFrequency) {
    state.newsletterFrequencyOfTheSelectedUser = selectedFrequency;
  },
  updateEndDate(state, endDate) {
    state.userObject.person.endDate = endDate;
  },
  updateStartDate(state, startDate) {
    state.userObject.person.startDate = startDate;
  },
  updateSasEndDate(state, sasEndDate) {
    state.userObject.person.sasEndDate = sasEndDate;
  },
  updateSasStartDate(state, sasStartDate) {
    state.userObject.person.sasStartDate = sasStartDate;
  },
  enableModalError(state) {
    state.hasModalError = true;
  },
  disableModalError(state) {
    state.hasModalError = false;
  },
  updateModalError(state, message) {
    state.modalErrorMessage = message;
  },
  updateSelectedSchemeResults(state, val) {
    const index = state.selectedSchemeResults.indexOf(val);
    if (index > -1) {
      state.selectedSchemeResults.splice(index, 1);
    } else {
      state.selectedSchemeResults.push(val);
    }
  },
  enableSuccessfullyUpdatedDialog(state) {
    state.showSuccessfullyUpdatedDialog = true;
  },
  disableSuccessfullyUpdatedDialog(state) {
    state.showSuccessfullyUpdatedDialog = false;
  },
  enableEmailSentDialog(state) {
    state.showEmailSentDialog = true;
  },
  disableEmailSentDialog(state) {
    state.showEmailSentDialog = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
